var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('head',[_c('meta',{attrs:{"name":"viewport","content":"width=device-width, initial-scale=1.0, user-scalable=no"}})])
}]

export { render, staticRenderFns }